export enum LocaleId {
    NB_NO = 'nb-no',
    SV_SE = 'sv-se',
    DA_DK = 'da-dk',
    EN_GB = 'en-gb',
}
